export default "__VITE_ASSET__D1fqKErQ__"